import React, {  useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import People from "./pages/People";
import Footer from "./components/base/Footer";
import Header from "./components/base/Header";
import Artist from "./pages/sections/participant/Artist";
import Profile from "./pages/Profile";
import SignIn from "./pages/SignIn";
import SignOut from "./pages/SignOut";
import PublicRoute from "./utils/PublicRoute";
import PrivateRoute from "./utils/PrivateRoute";
import Validate from "./pages/Validate";
import RefereeHomeRedirect from "./pages/RefereeHomeRedirect";
import RefereeDashboard from "./pages/RefereeDashboard";
import RefereeContest from "./pages/RefereeContest";
import Forgot from "./pages/user/Forgot";
import Reset from "./pages/Reset";
import Videos from "./pages/Videos";
import Post from "./pages/shared/post/Post";
import Posts from "./pages/shared/post/Posts";
import About from "./pages/shared/About";
import DeleteAccount from "./pages/DeleteAccount";

import Message from "./pages/Message";
import MessageDetails from "./pages/MessageDetails";
import Faqs from "./pages/Faqs";
import Slug from "./pages/Slug";
import CourseHistory from "./pages/sections/contest/CourseHistory";
import Poll from "./pages/sections/contest/Poll";
import Dashboard from "./pages/sections/participant/Dashboard";
import Contest from "./pages/sections/contest/Contest";
import FeedPage from "features/feature_feed/pages/FeedPage";
import Home from "pages/shared/Home/Home";
import CmsRoutes from "./cms/CmsRoutes";

function MainRoutes({translations}) {

  return (
      <Router  basename="/"> 
        <Switch>
          {/* CMS admin routes — rendered without the public Header/Footer */}
          <Route path="/cms" component={CmsRoutes} />

          {/* Public site routes */}
          <Route path="/">
            <Header translations={translations} />
            <Switch>
              <Route component={Home} path="/" exact />
              <Route component={SignOut} path="/signout" exact />
              <Route component={Forgot} path="/forgot" exact />
              <Route component={Reset} path="/reset" exact />
              <Route component={Validate} path="/validate" exact />
              <PrivateRoute component={DeleteAccount} path="/delete-account" exact />
              <Route component={Videos} path="/talent" exact />
              <Route component={Videos} path="/talent/:id" />
              <Route component={Posts} path="/blog/:id" />
              <Route component={Posts} path="/blog" />
              <Route component={Post} path="/post/:id" />
              <Route component={About} path="/about" />
              <Route component={Faqs} path="/faq" />
              <Route component={CourseHistory} path="/history/:id" />
              <Route component={People} path="/people/:id" />
              <Route component={Poll} path="/poll/:id" />
              <Route component={Poll} path="/vote/:id" />
              <Route component={Poll} path="/vote" />
              <Route component={FeedPage} path="/feed" />
              

              <PublicRoute component={SignIn} path="/signin" exact />
              <PrivateRoute component={Artist} path="/mytalents" exact />
              <PrivateRoute component={Dashboard} path="/dashboard" exact />
              <PrivateRoute component={RefereeHomeRedirect} path="/referee" exact />
              <PrivateRoute component={RefereeDashboard} path="/referee/dashboard" exact />
              <PrivateRoute component={RefereeContest} path="/referee/contest/:courseId" exact />
              <PrivateRoute component={Profile} path="/profile" exact />
              <PrivateRoute component={Contest} path="/contests" exact />
              {/* <PrivateRoute component={Talent} path="/mytalents" exact /> */}
              <PrivateRoute component={Message} path="/support" exact />
              <PrivateRoute component={MessageDetails} path="/support/:id" exact />
              <Route component={Slug} path="/:slug" />
            </Switch>
            <Footer translations={translations} />
          </Route>
        </Switch>
      </Router>
  );
}
export default MainRoutes;
